//external
import SimpleBar from 'simplebar-react';

//hooks
import { useObservable }  from 'thrive-observable-react';

//components
import { BasicButton } from 'thrive-components'
import ChatMenuListItem from '../components/menu/ChatMenuItem';

//services
import { CS } from '../service/Chat.Service';
import { ConversationService } from '../service/ChatConversation.Service';
import { CAS } from '../service/ChatConfig.Service';
import { ChatMenuItem } from '../components/menu/ChatMenuItem.Service';

//interfaces
import { IChatMeta } from '../interfaces';

// constants
import { chatMetaPlaceHolder } from '../../src/constants';

// utils
import { infiniteScroll } from '../utility/infiniteScroll';

//styling
import '../styles/ChatMenu.scss';


export function ChatMenu () {

    const chats = useObservable<IChatMeta[]>(CS.chats);
    const newChatIsOpen = useObservable<boolean>(CS.newChatsIsOpen)
    const infiniteScrollRef = infiniteScroll(
        () => CS.getNextPageOfChats(),
        CS.hasMoreChats(),
        document.querySelector('#chats-menu .simplebar-content')
    ) ?? undefined;

    const activeChatId = useObservable<number>(ConversationService.chatId);

     const chatIsLoaded = useObservable(CS.initialChatLoaded)

    return (
        <nav id='chats-menu'>
            <SimpleBar 
                className='simple-bar-config'
            >
                <ul className='chat-menu-chat-list'>
                    <ChatMenuListItem
                        key={`${0}-menu-item`}
                        chatItem={new ChatMenuItem(chatMetaPlaceHolder as IChatMeta, String(activeChatId))}
                    />
                    {chats.map((chat: any) => (
                    <ChatMenuListItem
                            key={`${chat.id}-menu-item`}
                            chatItem={new ChatMenuItem(chat, String(activeChatId))}
                    />
                    ))}
                    {chats.length === 0 && !newChatIsOpen &&
                        <div className='chat-placeholder-text no-conversations'>
                            {chatIsLoaded && CAS.localisationStrings.NoConversations()}
                        </div>
                    }
                    <div
                        className='pagination-buffer'
                        data-testid="infinite-scroll"
                        ref={infiniteScrollRef}
                    />   
                </ul>
                
            </SimpleBar> 
            <div className='fade-out'></div>    
            <div className='new-chat-wrapper'>
                <BasicButton
                    className='new-chat-button'
                    content={CAS.localisationStrings.NewChat()}
                    ariaLabel={CAS.localisationStrings.NewChat()}
                    onButtonClick={() => {CAS.openPeopleSearch()}}
                />
            </div>                 
        </nav>
        
    );
};

export default ChatMenu;

